import React, { useEffect, useState } from "react";

export default function Coupons() {
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
    // 🟢 Backend se coupon list fetch karo
    fetch("https://hrgf.salepatner.com/api/coupons/")
      .then((res) => res.json())
      .then((data) => setCoupons(data))
      .catch((err) => console.error("Error fetching coupons:", err));
  }, []);

  // 🔹 Copy code helper
  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    alert(`✅ Coupon code copied: ${code}`);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-10 px-6">
      <h1 className="text-3xl font-extrabold text-gray-800 mb-10 text-center">
        💸 Exclusive Coupons & Deals
      </h1>

      {coupons.length === 0 ? (
        <p className="text-center text-gray-500">Loading coupons...</p>
      ) : (
        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {coupons.map((coupon) => (
            <div
              key={coupon.id}
              className="group bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-xl transition transform hover:-translate-y-1"
            >
              {/* Header with brand name */}
              <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white px-5 py-3 flex items-center justify-between">
                <h2 className="text-lg font-semibold tracking-wide uppercase">
                  {coupon.store_name}
                </h2>
                <span className="text-sm bg-white/20 px-2 py-0.5 rounded-md">
                  {coupon.discount_type === "flat"
                    ? `₹${coupon.discount_value} Off`
                    : `${coupon.discount_value}% Off`}
                </span>
              </div>

              {/* Body */}
              <div className="p-5">
                <h3 className="text-gray-800 font-bold text-lg mb-2">
                  {coupon.title}
                </h3>
                <p className="text-gray-600 text-sm mb-2">
                  {coupon.description}
                </p>
                <p className="text-gray-400 text-xs mb-3">
                  🕒 Valid till {coupon.expiry_date}
                </p>

                {/* Coupon Code Box */}
                {coupon.code && (
                  <div className="bg-gray-100 border border-dashed border-gray-300 rounded-md flex justify-between items-center px-3 py-2 mb-3">
                    <span className="font-mono text-gray-700 text-sm">
                      {coupon.code}
                    </span>
                    <button
                      onClick={() => copyCode(coupon.code)}
                      className="text-indigo-600 text-xs font-semibold hover:underline"
                    >
                      Copy
                    </button>
                  </div>
                )}

                {/* Action buttons */}
                <div className="flex justify-between items-center mt-3">
                  <a
                    href={`https://hrgf.salepatner.com/api/coupons/${coupon.id}/use/`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-green-700 transition"
                  >
                    Go to {coupon.store_name}
                  </a>

                  <span className="text-xs text-gray-400">
                    {coupon.is_active ? "Active ✅" : "Expired ❌"}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
